import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';
import Tooltip from 'src/componentes/tooltip';
import ProgressBar from 'src/componentes/NewProgressBar';
import useAuth from 'src/hooks/useAuth';

export default function ToleranciaRiscoBarra({
  model = {},
  itens = [],
  exibirTitulo = true,
}) {
  const intl = useIntl();
  const { decimalSeparator, thousandsSeparator } = useAuth();

  const formatNumberWithAuthSeparators = (value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return `${value}`;

    const decimal = decimalSeparator || ',';
    const thousands = thousandsSeparator || '.';
    const decimalCount = Number.isInteger(numericValue) ? 0 : 2;

    const [integerPart, decimalPart] = numericValue
      .toFixed(decimalCount)
      .split('.');
    const integerWithSeparator = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      thousands
    );

    return decimalPart
      ? `${integerWithSeparator}${decimal}${decimalPart}`
      : integerWithSeparator;
  };

  const getBoundaryValueText = (value) => {
    if (value === null || value === undefined || value === '') return '-';

    if (typeof value === 'number') return formatNumberWithAuthSeparators(value);

    const numericValue = Number(value);
    if (!Number.isNaN(numericValue) && value !== '')
      return formatNumberWithAuthSeparators(numericValue);

    return `${value}`;
  };

  const hasLargeText = (value) => getBoundaryValueText(value).length > 7;

  const renderEmptyBar = () => (
    <div
      style={{ height: 25 }}
      className="d-flex justify-content-center align-items-center text-xs w-100"
    ></div>
  );

  const renderBar = () => {
    const primeiroItem =
      model?.itens && model?.itens.length > 0 ? model?.itens[0] : { de: 0 };
    const ultimoItem =
      model?.itens && model?.itens.length > 0
        ? model?.itens[model?.itens.length - 1]
        : { ate: 100 };
    const isEmpty =
      !model?.itens ||
      model?.itens.length === 0 ||
      model?.itens.every((x) => !x.percentual);

    return (
      <div className="d-flex align-items-center mb-1 pr-2">
        <Tooltip
          text={getBoundaryValueText(primeiroItem.de)}
          disabled={!hasLargeText(primeiroItem.de)}
        >
        <div
          className="pr-1 pt-2"
          style={{
            minWidth: 56,
            maxWidth: 100,
            flex: '0 0 auto',
            textAlign: 'right',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: primeiroItem?.cor ? primeiroItem.cor : '',
          }}
        >
          {getBoundaryValueText(primeiroItem.de)}
        </div>
        </Tooltip>
        {!isEmpty ? (
          <ProgressBar
            showBorder={false}
            labelSizeClass="text-xs"
            itens={model?.itens}
            showPercent={true}
            showLabel={false}
            hidePercentValue={10}
            containerHeight={20}
            showLegenda={false}
            utilizarMarcador={true}
            alertaMarcador={false}
            ajustarPercentualMarcador={0}
            showCursor={false}
            formatMarcadorValue={formatNumberWithAuthSeparators}
          />
        ) : (
          renderEmptyBar()
        )}
        <Tooltip
          text={getBoundaryValueText(ultimoItem.ate)}
          disabled={!hasLargeText(ultimoItem.ate)}
        >
        <div
          className="mr-1 pt-2"
          style={{
            minWidth: 56,
            maxWidth: 100,
            flex: '0 0 auto',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: ultimoItem?.cor ? ultimoItem.cor : '',
          }}
        >
          {getBoundaryValueText(ultimoItem.ate)}
        </div>
        </Tooltip>
      </div>
    );
  };

  const renderLegend = () => {
    return (
      <div>
        <Row className="pb-2 pt-1">
          <Col
            md={12}
            className="d-flex justify-content-center"
            style={{ fontSize: '11px', fontWeight: 'bold' }}
          >
            {model?.faixaAvaliacao?.descricao}
          </Col>
        </Row>
        {model?.itens &&
          model.itens.map((item, index) => (
            <Row
              key={`${item?.label || 'tolerancia'}-${index}`}
              className="pl-5 d-flex justify-content-center"
            >
              <Col md={1} className="p-0 pt-1">
                <div
                  style={{
                    width: '15px',
                    height: '15px',
                    backgroundColor: item.cor,
                  }}
                ></div>
              </Col>
              <Col
                md={10}
                className="pl-1 pt-1  text-bold"
                style={{ fontSize: '10px', fontWeight: 'bold' }}
              >
                {item.label}
              </Col>
            </Row>
          ))}
      </div>
    );
  };

  return model?.toleranciaRisco ? (
    <div>
      {exibirTitulo && (
        <Row className="pb-3 pt-1">
          <Col
            md={12}
            className="d-flex justify-content-center"
            style={{ fontSize: '12px', fontWeight: 'bold' }}
          >
            {intl.formatMessage({ id: 'labelTolerancia' })}:{' '}
            {model?.toleranciaRisco?.descricao}
          </Col>
        </Row>
      )}
      <Row>
        <Col md={12}>{renderBar()}</Col>
      </Row>
      <div className="pb-2">{renderLegend(itens)}</div>
    </div>
  ) : (
    <></>
  );
}